import Header from '../../components/Header'
import HeaderImage from '../../images/header_bg_3.jpg'
import './Gallery.css'
const Gallery = () => {
  let galleryLength = 15;
  let images = [];

  for (let i=1; i<= galleryLength; i++){
    images.push(require(`../../images/gallery${i}.jpg`))
  }
console.log(images)
  return (
    <>
    <Header title='Our Gallery' image={HeaderImage}>
      Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quod aliquid suscipit ad eos consequatur, dolorem impedit.
    </Header>
    <section className='gallery'>
      <div className='container gallery__container'>
        {
          images.map((image,index)=>{
            return <article key={index}>
              <img src={image} alt="gallery" />
            </article>
          })
        }
      </div>

    </section>
    </>
  )
}

export default Gallery